import { resolveTenant } from './resolve';

export const tenants = {
  full: 'full',
  crm: 'crm',
} as const;

export const tenant = resolveTenant();

export * from './types';
